<template>
  <v-main>
    <!-- TOP IMAGE -->
    <v-container
      class="col-10 pa-0 ma-0-auto mt-4 d-flex flex-column flex-lg-row page-wrapper mb-16"
    >
      <v-img
        src="@/assets/images/entrypages/national-cancer-institute-L7en7Lb-Ovc-unsplash.jpg"
        height="250"
      >
        <div
          class="page-img-title"
          style="margin-top: 30px; margin-left: 30px;"
        >
          <h4 class="page-title">
            <span
              style="background-color: white ; opacity: 0.9; padding: 10px;"
            >
              {{ $t(menu).content.title }}</span
            >
          </h4>
        </div>
      </v-img>
    </v-container>

    <!-- Bellow the image intro -->

    <v-container
      class="col-10 pa-0 ma-0-auto d-flex flex-column flex-lg-row page-wrapper"
    >
      <div class="col-12 col-lg-3 pa-0 page-sidebar">
        <SideMenu
          class="d-none d-lg-block"
          page="/technologies/"
          :menu="menu"
        ></SideMenu>
      </div>

      <div class="col-12 col-lg-9 pa-0 pt-16 pt-md-0 pl-lg-12 page-content">
        <v-row>
          <v-col class="col-12 col-sm-6 col-lg-6 pt-0 px-5 pb-6">
            <!-- BUTTONS -->
            <div class="d-flex justify-end filter-buttons mr-3">
              <!-- CLEAR BUTTON -->
              <v-btn
                rounded
                text
                color="red darken-4"
                class="px-3 mr-3 nav-item"
                :disabled="selected.length === 0"
                @click="clearFilters"
                >Clear</v-btn
              >
              <!-- FILTER BUTTON -->
              <div v-for="(techFilters, i) in technologiesFilters" :key="i">
                <div v-if="techFilters.show">
                  <v-btn
                    tile
                    text
                    class="px-3 nav-item green white--text d-block"
                    @click="openIpStatusFilter = !openIpStatusFilter"
                  >
                    <v-icon class="mr-2">mdi-filter-variant</v-icon>

                    {{ techFilters.name }}
                    <span v-if="selected.length">({{ selected.length }})</span>
                  </v-btn>
                  <div
                    class="filter-panel lightgray"
                    v-if="openIpStatusFilter"
                    v-click-outside="onClickOutside"
                  >
                    <div
                      v-for="(techFiltersNames, j) in techFilters.filters"
                      :key="j"
                    >
                      <v-checkbox
                        v-model="selected"
                        :label="techFiltersNames.name"
                        color="green"
                        :value="techFiltersNames.name"
                        @change="
                          filteredTechnologies(
                            techFilters.name,
                            techFiltersNames.name
                          )
                        "
                      ></v-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div> </v-col
        ></v-row>
        <v-row>
          <v-col
            v-for="(technology, i) in technologiesFiltered"
            :key="i"
            class="col-12 col-sm-6 col-lg-6 pt-0 px-5 pb-10"
          >
            <TechnologyCard :content="technology" />
          </v-col>
        </v-row>
      </div>
    </v-container>
  </v-main>
</template>

<script>
import TechnologyCard from '@/components/TechnologyCard'
import SideMenu from '@/components/SideMenu'

export default {
  name: 'TechnologiesList',
  components: { TechnologyCard, SideMenu },
  data() {
    return {
      technologies: this.$t('technologies'),
      technologiesFilters: this.$t('technologiesFilters'),
      technologiesFiltered: this.$t('technologies'),
      selected: [],
      openIpStatusFilter: false,
      menu: 'SideMenuTechnologies',
    }
  },
  methods: {
    clearFilters() {
      this.selected = []
      this.technologiesFiltered = this.technologies
    },
    onClickOutside() {
      this.openIpStatusFilter = false
    },

    filteredTechnologies(filterName, filterOption) {
      if (filterName === 'IP Status') {
        if (this.selected.length) {
          this.technologiesFiltered = this.filterByIpStatus(filterOption)
        } else {
          this.clearFilters()
        }
      } else if (filterName === 'Area of Knowledge') {
        if (this.selected.length) {
          this.technologiesFiltered = this.filterByAreaOfKnowledge(filterOption)
        } else {
          this.clearFilters()
        }
      }

      return this.technologiesFiltered
    },

    filterByIpStatus(filterOption) {
      return this.technologies.filter(el => {
        return this.selected.includes(el.filters[0].ipStatus[0])
      })
    },

    filterByAreaOfKnowledge(filterOption) {
      return this.technologies.filter(tech => {
        for (let i = 0; i < tech.filters[2].areaKnowledge.length; i++) {
          for (let j = 0; j < this.selected.length; j++) {
            if (this.selected[j] === tech.filters[2].areaKnowledge[i]) {
              return tech
            }
          }
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.filter-buttons {
  position: absolute;
  top: 300px;
  right: calc(100vw / 12);
  .nav-item {
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      font-size: 12px !important;
    }
  }
}

.filter-panel {
  position: absolute;
  z-index: 1;
  width: calc(100vw / 12 * 2.5);
  padding: 30px 15px 15px 15px;
  right: 0;
  font-family: $body-font-family;
  font-weight: normal;
  box-shadow: 0 14px 28px rgba(0, 0, 0, 0.25), 0 10px 10px rgba(0, 0, 0, 0.22);

  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    width: calc(100vw / 12 * 6);
  }

  .v-input {
    margin: 0;
    padding: 0;
    .v-input__slot {
      margin: 0 !important;
    }
  }
}

.page-title {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    font-size: 20px;
  }
}
</style>
